module.exports = __webpack_public_path__ + "img/1280x720-Summer.8f46d1f0.jpg";